import { render } from "./InternalPageSelector.vue?vue&type=template&id=4a9d404e"
import script from "./InternalPageSelector.vue?vue&type=script&lang=js"
export * from "./InternalPageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__